import { useState, useEffect } from "react";
import { Button } from "@mui/material";
import {
  Switch,
  FormControlLabel,
  TextField,
  Grid,
  CardActions,
  CardContent,
  CardHeader,
  Card,
  Loading,
} from "../../../components";
import { notification, SubgrupoProdutosService } from "../../../services";
import { InputErros, PermisoesHelper } from "../../../helpers";
import { responseErros } from "../../../utils";
import subgrupoProdutosValidator from "./middlewares/subgrupoProdutos.validator";
import { SubgrupoProdutoEntity } from "../entities";

const AddSubgruposProdutos = ({
  id,
  handleCloseDialog,
  buscaSubgruposProdutos,
}) => {
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("grupo-produtos-visualizar");
  const [loading, setLoading] = useState(false);
  const [subgrupoProdutos, setSubgrupoProdutos] = useState({ ativado: true });
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const subgrupoProdutosService = new SubgrupoProdutosService();

  useEffect(() => {
    if (id) {
      buscarSubgrupoProdutos();
    }
  }, []);

  const buscarSubgrupoProdutos = async () => {
    setLoading(true);
    const result = await subgrupoProdutosService.getById(id);
    if (!result.isAxiosError) {
      setSubgrupoProdutos(result.data);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const handleInputChange = (event) => {
    setSubgrupoProdutos((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    subgrupoProdutosValidator
      .validate(subgrupoProdutos, { abortEarly: false })
      .then(async () => {
        const subgrupoProdutoEntity = new SubgrupoProdutoEntity(
          subgrupoProdutos
        );
        if (id) {
          const response = await subgrupoProdutosService.atualizar(
            id,
            subgrupoProdutoEntity
          );
          setLoading(false);
          if (!response.isAxiosError) {
            handleCloseDialog();
            notification.alteracaoSucesso();
            buscaSubgruposProdutos();
          } else {
            responseErros(response);
          }
        } else {
          const response = await subgrupoProdutosService.cadastrar(
            subgrupoProdutoEntity
          );
          setLoading(false);
          if (!response.isAxiosError) {
            handleCloseDialog();
            notification.cadastroSucesso();
            buscaSubgruposProdutos();
          } else {
            responseErros(response);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        inputErros.set(err);
      });
  };

  const handleCancelar = () => {
    setSubgrupoProdutos(null);
    handleCloseDialog();
  };

  return (
    <>
      <Card className="p-3">
        <CardHeader
          title={
            id
              ? "Editar Subgrupo de Produtos"
              : "Cadastrar Subgrupo de Produtos"
          }
          action={
            <FormControlLabel
              control={
                <Switch
                  checked={
                    subgrupoProdutos?.ativado
                      ? subgrupoProdutos?.ativado
                      : false
                  }
                  onChange={() =>
                    setSubgrupoProdutos((prevState) => ({
                      ...prevState,
                      ativado: !prevState?.ativado,
                    }))
                  }
                  name="ativado"
                  color="primary"
                />
              }
              label={subgrupoProdutos?.ativado ? "Ativado" : "Desativado"}
            />
          }
        />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                id="descricao"
                name="descricao"
                label="Descrição"
                variant="outlined"
                value={
                  subgrupoProdutos?.descricao ? subgrupoProdutos.descricao : ""
                }
                onChange={(event) => {
                  setInputErro([]);
                  handleInputChange(event);
                }}
                fullWidth
                required
                error={inputErros.get("descricao")}
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          <Button
            color="primary"
            variant="contained"
            disabled={!permissoesHelper.temPermisao("grupo-produtos-cadastrar")}
            onClick={handleSubmit}
          >
            <i
              className="ph-fill ph-check-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Salvar
          </Button>
          <Button color="padrao" variant="contained" onClick={handleCancelar}>
            <i
              className="ph-fill ph-x-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Fechar
          </Button>
        </CardActions>
      </Card>
      <Loading loading={loading} />
    </>
  );
};

export default AddSubgruposProdutos;
